import { render, staticRenderFns } from "./roomModal.vue?vue&type=template&id=31db06aa&scoped=true&"
import script from "./roomModal.vue?vue&type=script&lang=js&"
export * from "./roomModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31db06aa",
  null
  
)

export default component.exports